import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {getAlertCorrelation, getAlertLogDetails, getRunbook} from "../../store/alertlog/actions";
import {Badge, Col, Modal, ModalBody, Popover, PopoverBody, Row, UncontrolledTooltip} from "reactstrap";
import {getIntegrationLogo, getLocalDateTime, getUserColor} from "../../helpers/component_helpers";
import CardItem from "../../components/PurpleTheme/CardItem";
import Card from "components/PurpleTheme/Card";
import CardHeader from "components/PurpleTheme/CardHeader";
import "./style.scss"
import InitialsAvatar from "../Profile/InitialsAvatar";
import profileImg from "../../assets/images/profile.png";
import Runbook from "../../components/Runbooks/Runbook";


const AlertCorrelationDetails = () => {
    const { alert_correlation_data } = useSelector(state => ({
        alert_correlation_data: state.AlertLog.alert_correlation_data}))
    const { id } = useParams();
    const dispatch = useDispatch();
    const [alertPopover,setAlertPopover] = useState({});
    const [popoverOpen2, setPopoverOpen2] = useState({});
    const [popoverOpen3, setPopoverOpen3] = useState({});
    const [popoverOpen4, setPopoverOpen4] = useState({});
    const [userColors, setUserColors] = useState([]);
    const [analyticsData, setAnalyticsData] = useState([]);
    const [showRunBookModal, setShowRunBookModal] = useState(false);

    useEffect(() => {
        if (alert_correlation_data?.root_cause_analysis) {
            const points = Array.isArray(alert_correlation_data.root_cause_analysis)
              ? alert_correlation_data.root_cause_analysis
              : alert_correlation_data.root_cause_analysis
                .split(/\.\s+/)
                .filter(point => point.trim().length > 0);
            setAnalyticsData(points);
        }
    }, [alert_correlation_data?.root_cause_analysis]);
    useEffect(() => {
        let userColorsMap = [];
        alert_correlation_data?.associated_alerts?.map((alert, index) => {
            if (alert.assigned_to) {
                let userColor = {};
                userColor = {
                    id: alert.assigned_to.id,
                    name: alert.assigned_to.name,
                    color: getUserColor(alert.assigned_to.email),
                }
                userColorsMap.push(userColor);
            }
        });
        setUserColors(userColorsMap);
    }, [alert_correlation_data]);

    useEffect(() => {
        dispatch(getAlertCorrelation(id))
    }, [id])
    const handleMouseEnterAlert = (id) => {
        setAlertPopover(prevState => ({
            ...prevState,
            [id]: true,
        }));
    };

    const handleMouseLeaveAlert = (id) => {
        setAlertPopover(prevState => ({
            ...prevState,
            [id]: false,
        }));
    };
    const togglePopoverMetric = (key, isOpen) => {
        setPopoverOpen4(prevState => ({
            ...prevState,
            [key]: isOpen,
        }));
    };

    const togglePopoverResource = (key, isOpen) => {
        setPopoverOpen3(prevState => ({
            ...prevState,
            [key]: isOpen,
        }));
    };

    const handleMouseEnterService = (key) => {
        togglePopoverService(key, true);
    };

    const handleMouseLeaveService = (key) => {
        togglePopoverService(key, false);
    };
    const handleMouseEnterResource = (key) => {
        togglePopoverResource(key, true);
    };

    const handleMouseEnterMetric = (key) => {
        togglePopoverMetric(key, true);
    };
    const handleMouseLeaveMetric = (key) => {
        togglePopoverMetric(key, false);
    };

    const handleMouseLeaveResource = (key) => {
        togglePopoverResource(key, false);
    };

    const togglePopoverService = (key, isOpen) => {
        setPopoverOpen2(prevState => ({
            ...prevState,
            [key]: isOpen,
        }));
    };
    const hasRootCauseDetails = alert_correlation_data?.root_cause_alert_details ?
        Object.keys(alert_correlation_data.root_cause_alert_details).length !== 0 : false;

    function handleClickViewRunbook() {
        dispatch(getRunbook(alert_correlation_data?.root_cause_alert_details?.id))
        dispatch(getAlertLogDetails(alert_correlation_data?.root_cause_alert_details?.id));
        setShowRunBookModal(true)
    }
    function handleView() {
        setShowRunBookModal(false)
    }

    return (
      <React.Fragment>
        <div>
            <>
                {/*<div className="bx bx-undo pe-3" onClick={() => window.history.back()}*/}
                {/*     style={{fontSize: "30px", cursor: "pointer", color: "white"}}></div>*/}
                <div className="modal-body p-2">
                    {/* Root Cause Analysis Section */}
                    <div className="d-flex flex-column">
                        <div className='d-flex align-items-center gap-3 mb-4'>
                            <h5 className="fw-bold m-0">Root Cause Analysis <img src="/icons/ai-compressed.png" alt="Customize Icon"
                                                                                 className="me-2 ms-2 ai-svg-icon"/></h5>
                        </div>
                        {/* Root Cause Alert Row */}
                        {/*{hasRootCauseDetails && (*/}
                        {/*  <div className="row mb-3 align-items-center">*/}
                        {/*      <div className="col-3">*/}
                        {/*          <h6 className="mb-0">Root Cause Alert:</h6>*/}
                        {/*      </div>*/}
                        {/*      <div className="col">*/}
                        {/*          <p className="mb-0">{alert_correlation_data?.root_cause_alert ? 'Yes' : 'No'}</p>*/}
                        {/*      </div>*/}
                        {/*  </div>*/}
                        {/*)}*/}

                        {/* Conditionally Render Root Cause Details */}
                        {(!alert_correlation_data?.root_cause_alert && hasRootCauseDetails) && (
                          <div className="row mb-3 align-items-center">
                              <div className="col-3">
                                  <h6 className="mb-0">Root Cause Details:</h6>
                              </div>
                              <div className="col">
                                  <Link
                                    to={`/alert-log/${alert_correlation_data?.root_cause_alert_details?.id}`}
                                    className="link-primary text-decoration-none"
                                  >
                                      {alert_correlation_data?.root_cause_alert_details?.name || 'N/A'}
                                  </Link>
                              </div>
                          </div>
                        )}
                        {alert_correlation_data?.root_cause_alert_details?.runbook_available && (
                          <div className="row mb-3 align-items-center">
                              <div className="col-3">
                                  <h6 className="mb-0">Runbook:</h6>
                              </div>
                              <div className="col">
                                  <button className="btn btn-primary"
                                          onClick={() => handleClickViewRunbook()}>View Runbook
                                  </button>
                              </div>
                          </div>
                        )}

                        {/* Analysis Row */}
                        <div className="row mb-3 align-items-start">
                            <div className="col-3">
                                <h6 className="mb-0">Analysis:</h6>
                            </div>
                            <div className="col">
                                {Array.isArray(analyticsData) ? (
                                    <ul className="list-disc pl-6 space-y-2">
                                        {analyticsData.map((point, index) => (
                                          <li key={index} className="text-gray-800">
                                              {point}
                                          </li>
                                        ))}
                                    </ul>
                                  ):(
                                  <p className="mb-0">
                                    {alert_correlation_data?.root_cause_analysis || 'No analysis available.'}
                                  </p>
                                      )}
                            </div>
                        </div>
                    </div>

                    <hr className="my-4"/>

                    {alert_correlation_data?.associated_alerts?.length > 0 ? (
                      <>
                          <h5>Associated Alerts</h5>
                          <div className="mt-3 mb-4">
                              <Card>
                                  <div className="d-flex flex-column align-items-center">
                                      <CardHeader className="w-100">
                                          <Row className="align-items-center bg-transparent w-100">
                                              <Col md="2">
                                                  <div className="text-center">
                                                      {"Alert Name"}
                                                  </div>
                                              </Col>
                                              <Col md="1">
                                                  <div className="text-center">
                                                      {"Source"}
                                                  </div>
                                              </Col>
                                              <Col md="1">
                                                  <div className="text-center">
                                                      {"Application"}
                                                  </div>
                                              </Col>
                                              <Col md="2">
                                                  <div className="text-center">
                                                      {"Resource"}
                                                  </div>
                                              </Col>
                                              <Col md="2">
                                                  <div className="text-center">
                                                      {"Metric"}
                                                  </div>
                                              </Col>
                                              <Col md="1">
                                                  <div className="text-center">
                                                      {"Status"}
                                                  </div>
                                              </Col>
                                              <Col md="1">
                                                  <div className="text-center">
                                                      {"Assigned To"}
                                                  </div>
                                              </Col>
                                              <Col md="1">
                                                  <div className="text-center">
                                                      {"Opened At"}
                                                  </div>
                                              </Col>
                                              <Col md="1">
                                                  <div className="text-center">
                                                      {"Closed At"}
                                                  </div>
                                              </Col>
                                          </Row>
                                      </CardHeader>

                                      {alert_correlation_data?.associated_alerts.map((item, index) => (
                                        <CardItem
                                          key={index}
                                          className={item?.is_root_cause ? 'carditem-root-cause' : ''}
                                        >
                                            <Row className="align-items-center">
                                                    <Col md="2" className="align-items-start">
                                                        <div
                                                          className="d-flex align-items-center justify-content-center">
                                                            <Link
                                                              className="resource-name-truncate text-center"
                                                              id={`alertlog-alert-name-${item.id}`}
                                                              to={`/alert-log/${item.id}`}
                                                              onMouseEnter={() => handleMouseEnterAlert(item.id)}
                                                              onMouseLeave={() => handleMouseLeaveAlert(item.id)}
                                                            >
                                                                {item.name.length > 25 ? item.name.substring(0, 25) + "..." : item.name}
                                                            </Link>
                                                            <Popover
                                                              isOpen={alertPopover[item.id] || false}
                                                              target={`alertlog-alert-name-${item.id}`}
                                                              placement="top"
                                                            >
                                                                <PopoverBody>{item.name}</PopoverBody>
                                                            </Popover>
                                                        </div>
                                                    </Col>
                                                    <Col md="1" className="text-center">
                                                        <div className='text-center'>
                                                            <img
                                                              src={getIntegrationLogo(
                                                                item.integration_type ||
                                                                alerts?.find(alert => alert?.id === item?.id)?.integration_type
                                                              )}
                                                              alt={item.integration_type}
                                                              className="avatar-xxs rounded-circle"
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md="1" className="text-center">
                                                        <h6 className="resource-name-truncate mb-0">
                                                            <Link
                                                              id={`alertlog-service-name-${item.id}`}
                                                              to={`/temperstack-notifications/${item.application_service_id}`}
                                                              onMouseEnter={() => handleMouseEnterService(item.id)}
                                                              onMouseLeave={() => handleMouseLeaveService(item.id)}
                                                              className="link-primary text-center"
                                                            >
                                                                {item.application_service.name}
                                                            </Link>
                                                            <Popover
                                                              isOpen={popoverOpen2[item.id] || false}
                                                              target={`alertlog-service-name-${item.id}`}
                                                              placement="top"
                                                            >
                                                                <PopoverBody>{item.application_service.name}</PopoverBody>
                                                            </Popover>
                                                        </h6>
                                                    </Col>
                                                    <Col md="2" className="text-center">
                                                        <h6
                                                          id={`alertlog-resource-${item?.id}`}
                                                          className='resource-name-truncate mb-0'
                                                          onMouseEnter={() => handleMouseEnterResource(item.id)}
                                                          onMouseLeave={() => handleMouseLeaveResource(item.id)}
                                                        >
                                                            {item.resource_name}
                                                        </h6>
                                                        <Popover isOpen={popoverOpen3[item.id] || false}
                                                                 target={`alertlog-resource-${item?.id}`}
                                                                 placement="top">
                                                            <PopoverBody>{item.resource_name}</PopoverBody>
                                                        </Popover>

                                                    </Col>
                                                    <Col md="2" className="text-center">
                                                        <h6
                                                          id={`alertlog-metric-${item?.id}`}
                                                          className='resource-name-truncate mb-0'
                                                          onMouseEnter={() => handleMouseEnterMetric(item.id)}
                                                          onMouseLeave={() => handleMouseLeaveMetric(item.id)}
                                                        >
                                                            {item.metric_name}
                                                        </h6>
                                                        <Popover isOpen={popoverOpen4[item.id] || false}
                                                                 target={`alertlog-metric-${item?.id}`} placement="top">
                                                            <PopoverBody>{item.metric_name}</PopoverBody>
                                                        </Popover>
                                                    </Col>
                                                    <Col md="1" className="text-center">
                                                        <Badge
                                                          className="font-size-10"
                                                          color={
                                                              item.status === "Alarm"
                                                                ? "danger"
                                                                : item.status === "Ok"
                                                                  ? "success"
                                                                  : "warning"
                                                          }
                                                        >
                                                            {item.status === "Acknowledged" ? "Acked" : item.status}
                                                        </Badge>
                                                    </Col>
                                                    <Col md="1" className="text-center"
                                                         style={{justifyContent: 'center', display: 'flex'}}>
                                                        {item.assigned_to?.profile_picture_url ? (
                                                          <div>
                                                              <img
                                                                id={`TooltipTop_${index}`}
                                                                src={item.assigned_to?.profile_picture_url}
                                                                alt="Profile"
                                                                style={{
                                                                    borderRadius: "50%",
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    marginBottom: "10px"
                                                                }}
                                                              />
                                                              <UncontrolledTooltip placement="top"
                                                                                   target={`TooltipTop_${index}`}>
                                                                  {item.assigned_to?.name}
                                                              </UncontrolledTooltip>
                                                          </div>
                                                        ) : ((item.assigned_to?.name) ?
                                                            <div><InitialsAvatar
                                                              name={item.assigned_to?.name}
                                                              id={`TooltipTop_${index}`}
                                                              userColor={userColors.find((user) => user.id === item.assigned_to?.id)?.color}
                                                              dimensions="40px"
                                                              marginBottom='0'
                                                            />
                                                                <UncontrolledTooltip placement="top"
                                                                                     target={`TooltipTop_${index}`}>
                                                                    {item.assigned_to?.name}
                                                                </UncontrolledTooltip>
                                                            </div> :
                                                            <img src={profileImg} alt="default profile"
                                                                 style={{height: "30px", width: "30px"}}/>
                                                        )}
                                                    </Col>
                                                    <Col md="1" className="text-center">
                                                        {getLocalDateTime(item.opened_at)}
                                                    </Col>
                                                    <Col md="1" className="text-center">
                                                        {getLocalDateTime(item.closed_at)}
                                                    </Col>
                                                </Row>
                                        </CardItem>
                                      ))}
                                  </div>
                              </Card>
                          </div>
                      </>
                    ) : <></>}
                </div>
            </>
        </div>
          <Modal
            isOpen={showRunBookModal}
            toggle={handleView}
            size={'xl'}
          >
              <ModalBody>
                  <Runbook
                    runbookView={true}
                    handleView={handleView}
                    id={alert_correlation_data?.root_cause_alert_details?.id}
                    metricName={alert_correlation_data?.root_cause_alert_details?.name}
                  />
              </ModalBody>
          </Modal>
      </React.Fragment>
    );
};

export default AlertCorrelationDetails;
